export default "__VITE_ASSET__SlHWUZn$yNWlWh_Qo6Vt3w__";